import React from "react";
import { useNavigate } from "react-router-dom";

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <button
          onClick={() => navigate(-1)}
          style={styles.backButton}
        >
          ← Back
        </button>

        <h1 style={styles.title}>Privacy Policy</h1>

        <p style={styles.date}>Last updated: May 2026</p>

        <p>
          This Privacy Policy explains how SC IMAA 888 SRL, Romania
          (“AskUniverse”, “we”, “our”, or “us”) collects, uses, stores, and
          protects your information when you use the AskUniverse application,
          website, and related services.
        </p>

        <h2 style={styles.h2}>1. Information We Collect</h2>
        <p>We may collect the following categories of information:</p>
        <ul>
          <li>Email address and account details</li>
          <li>Questions, prompts, dreams, messages, and app interactions</li>
          <li>Love Portal interactions, soulmate or twin flame reflections</li>
          <li>Subscription and payment status information</li>
          <li>Usage data, device information, browser type, IP address, and technical logs</li>
          <li>Analytics and advertising interaction data</li>
        </ul>

        <h2 style={styles.h2}>2. How We Use Your Information</h2>
        <ul>
          <li>To provide AI-generated responses and app functionality</li>
          <li>To personalize user experience and improve the service</li>
          <li>To manage subscriptions, payments, billing, and customer support</li>
          <li>To maintain security, prevent misuse, and troubleshoot technical issues</li>
          <li>To analyze usage patterns and improve advertising performance</li>
        </ul>

        <h2 style={styles.h2}>3. AI Processing</h2>
        <p>
          Some questions, prompts, dreams, relationship reflections,
          soulmate interpretations, or interactions submitted by users may
          be processed by artificial intelligence systems in order to generate
          responses, interpretations, and personalized experiences.
        </p>

        <h2 style={styles.h2}>4. Third-Party Services</h2>
        <p>We may use trusted third-party providers, including:</p>
        <ul>
          <li>OpenAI for AI processing</li>
          <li>Stripe for payments and subscriptions</li>
          <li>MongoDB for secure data storage</li>
          <li>TikTok Pixel for advertising analytics and campaign optimization</li>
          <li>Hosting, analytics, and technical infrastructure providers</li>
        </ul>

        <h2 style={styles.h2}>5. Cookies and Tracking Technologies</h2>
        <p>
          We may use cookies, pixels, and similar technologies to understand user
          interactions, improve performance, remember preferences, analyze traffic,
          and optimize advertising campaigns.
        </p>

        <p>
          This may include TikTok Pixel and similar advertising technologies,
          which may collect device information, browsing behavior, and interaction
          data for analytics and advertising performance.
        </p>

        <h2 style={styles.h2}>6. Payments and Subscriptions</h2>
        <p>
          Payment information is processed securely by third-party payment
          providers such as Stripe. AskUniverse does not store full payment card
          details on its servers.
        </p>

        <h2 style={styles.h2}>7. Data Sharing</h2>
        <p>
          We do not sell personal data to third parties. We may share limited data
          with trusted service providers only when necessary to operate the app,
          process payments, provide AI functionality, improve performance, or
          comply with legal obligations.
        </p>

        <h2 style={styles.h2}>8. International Data Transfers</h2>
        <p>
          Your information may be processed and stored in countries outside your
          jurisdiction through trusted third-party service providers. We take
          reasonable steps to protect your data in accordance with applicable law.
        </p>

        <h2 style={styles.h2}>9. Data Security</h2>
        <p>
          We use reasonable administrative, technical, and organizational measures
          to protect your personal data. However, no digital service can guarantee
          absolute security.
        </p>

        <h2 style={styles.h2}>10. Data Retention</h2>
        <p>
          We retain personal data only as long as necessary for the purposes
          described in this Privacy Policy, including providing the service,
          maintaining records, resolving disputes, and complying with legal
          obligations.
        </p>

        <h2 style={styles.h2}>11. Your Rights</h2>
        <p>Depending on your location, you may have the right to:</p>
        <ul>
          <li>Request access to your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your account and personal data</li>
          <li>Object to or restrict certain processing activities</li>
          <li>Withdraw consent where processing is based on consent</li>
        </ul>

        <p>
          To exercise these rights, contact us at{" "}
          <strong>support@askuniverse.app</strong>.
        </p>

        <h2 style={styles.h2}>12. Children’s Privacy</h2>
        <p>
          AskUniverse is not intended for children under 13. Users under 18 should
          use the service only with parental or legal guardian consent.
        </p>

        <h2 style={styles.h2}>13. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be
          posted on this page. Continued use of AskUniverse after updates means
          you accept the revised policy.
        </p>

        <h2 style={styles.h2}>14. Contact</h2>
        <p>
          SC IMAA 888 SRL <br />
          Romania <br />
          <strong>support@askuniverse.app</strong>
        </p>

        <p style={styles.footer}>©️ 2026 AskUniverse. All rights reserved.</p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #07122b 0%, #020816 100%)",
    color: "#fff",
    padding: "40px 20px",
  },
  card: {
    maxWidth: "900px",
    margin: "0 auto",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "20px",
    padding: "32px",
    lineHeight: 1.7,
  },
  backButton: {
    background: "transparent",
    color: "white",
    border: "1px solid rgba(255,255,255,0.35)",
    padding: "8px 14px",
    borderRadius: "10px",
    marginBottom: "24px",
    cursor: "pointer",
  },
  title: {
    fontSize: "40px",
    marginBottom: "8px",
  },
  date: {
    opacity: 0.8,
    marginBottom: "24px",
  },
  h2: {
    marginTop: "28px",
    fontSize: "22px",
  },
  footer: {
    marginTop: "40px",
    opacity: 0.7,
  },
};
